module.exports = __webpack_public_path__ + "static/koltech-person.1a1fd647.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/koltech-person.jpeg
// module id = 701
// module chunks = 35783957827783